module.exports = __webpack_public_path__ + "img/Feature.115f90b2.png";